import React from 'react';
import { useDispatch } from 'react-redux';
import { resendInvitionToMeetingRoom, cancelInvitionToMeetingRoom } from '../actions/meetingRoom';
import { showMRManageRolesModal } from '../actions/modal.js';
import { ContextualMenu, forceCloseContextualMenu } from '../components/shared/contextualMenu/content';

function MeetingRoomManageUsersActionMenu(props) {
  const dispatch = useDispatch();

  const clickManageRoles = (userId) => {
    dispatch(showMRManageRolesModal(true));
  };

  const resendInvitation = (user) => {
    dispatch(resendInvitionToMeetingRoom(props.selectedMeetingRoom, user));

    setTimeout(() => {
      forceCloseContextualMenu('.manage-users-meeting-room-container');
    }, 100);
  };

  const cancelnvitation = (user) => {
    dispatch(cancelInvitionToMeetingRoom(props.selectedMeetingRoom, user));

    setTimeout(() => {
      forceCloseContextualMenu('.manage-users-meeting-room-container');
    }, 100);
  };

  return (
    <ContextualMenu
      id={props.selectedUser.id}
      options={[
        {
          title: APP.LANGUAGE.MeetingRoomUserActionMenu.ManageRoles,
          customAction: false,
          show:
            !props.selectedUser.isEmailOnlyUser &&
            props.selectedMeetingRoom.permissions.indexOf('MANAGE_MEMBER_ROLES') > -1,
          action: () => clickManageRoles(props.selectedUser.id),
        },
        {
          title: APP.LANGUAGE.MeetingRoomUserActionMenu.ResendInvite,
          customAction: false,
          show: props.selectedUser.isEmailOnlyUser,
          action: () => resendInvitation(props.selectedUser),
        },
        {
          title: APP.LANGUAGE.MeetingRoomUserActionMenu.CancelInvite,
          customAction: false,
          show: props.selectedUser.isEmailOnlyUser,
          action: () => cancelnvitation(props.selectedUser),
        },
      ]}
    />
  );
}

export default MeetingRoomManageUsersActionMenu;
